/** In-memory cache of dataset column schemas (shared by map builder and color picker). */
const cache = new Map();

export const getDatasetSchema = (datasetId) => cache.get(datasetId);

export const setDatasetSchema = (datasetId, schema) => {
  if (datasetId && schema?.length) {
    cache.set(datasetId, schema);
  }
};
